// Section for import npm components -----------------------------------------------------------------------------------
import React, { createContext, useState, useContext } from 'react';

// Section for type definition -----------------------------------------------------------------------------------------

type SelectedStations = number[] | [];
const initSelectedStations: SelectedStations = [];

export const SelectedStationsContext: React.Context<SelectedStations> = createContext(initSelectedStations);
export const UpdateSelectedStations: React.Context<any> = createContext(initSelectedStations);
// export const SelectedStationsConsumer = SelectedStationsContext.Consumer;
export const useSelectedStations = () => useContext(SelectedStationsContext);
export const useUpdateSelectedStations = () => useContext(UpdateSelectedStations);

// Section for render component ----------------------------------------------------------------------------------------
function SelectedStationsProvider(props: any): React.JSX.Element {
  const { children } = props;
  const [selectedStations, setSelectedStations] = useState([]);
  // valueにグローバルに扱う値を設定
  return (
    <SelectedStationsContext.Provider value={selectedStations}>
      <UpdateSelectedStations.Provider value={setSelectedStations}>{children}</UpdateSelectedStations.Provider>
    </SelectedStationsContext.Provider>
  );
}

export default SelectedStationsProvider;
